import Gallery from "./gallery-body";

export default Gallery;